import { Box } from '@mui/material';
import { ScreenTitle } from 'components';
import { useAppSelector, useAuth0 } from 'hooks';
import { usePatientData } from './hooks';
import React, { useCallback } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { tokens } from 'theme';
import { COLUMNS } from './constants';
import { useTheme } from 'hooks';
import styles from './styles.module.sass';

export const PatientInfo = () => {
  const userInfo = useAppSelector(({ user }) => user.data);
  const { user } = useAuth0();
  const { patientFormattedData, isDataLoading } = usePatientData(user);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const generateContent = useCallback(() => {
    if (!userInfo?.patientId) {
      return <h2 className={styles.title}>No patient id</h2>;
    }

    if (!patientFormattedData) {
      return <h2 className={styles.title}>Loading...</h2>;
    }

    return (
      <>
        <ScreenTitle title='PATIENT' />
        <Box
          sx={{
            '& .MuiDataGrid-root': {
              border: 'none',
              overflowY: 'hidden',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
              width: '0.4em',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
              background: '#f1f1f1',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
              backgroundColor: colors.dashboard.secondary,
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: colors.dashboard.secondary,
              borderBottom: 'none',
            },
          }}
        >
          <DataGrid
            getRowId={() => crypto.randomUUID()}
            rowHeight={400}
            rows={patientFormattedData}
            columns={COLUMNS}
            sx={{ overflowX: 'auto' }}
            loading={isDataLoading}
            disableColumnFilter
            hideFooter
          />
        </Box>
      </>
    );
  }, [colors.dashboard.secondary, isDataLoading, patientFormattedData, userInfo?.patientId]);

  return generateContent();
};
